export default {
  tabLabel: 'Audit',
  loadingAudit: 'Loading audit…',
  loadAuditError: 'Could not load the audit: {{message}}',
  contextDebtTitle: 'Context debt',
  contextDebtDescription:
    'How difficult it is to restore working context without asking people.',
  collectingData: 'Collecting data…',
  collectData: 'Collect data',
  generatingReport: 'Generating…',
  generateReport: 'Generate report',
  ingestError: 'Data collection failed: {{message}}',
  generateError: 'Could not generate the report: {{message}}',
  clearHistoryError: 'Could not clear report history: {{message}}',
  scanFailed: 'The scan failed: {{message}}',
  metricsTitle: 'Metrics',
  noData:
    'No data yet. Connect sources under Plugins and select “Collect data”.',

  chartNotEvaluated:
    'Context Debt was not evaluated because no source returned data.',
  debtBandLow: 'low',
  debtBandModerate: 'moderate',
  debtBandHigh: 'high',
  debtBandCritical: 'critical',
  trendAfterReport:
    'The trend will appear after the first generated report. The line uses saved versions rather than the current preview.',
  oneMeasurement:
    'There is one measurement so far. The line shows growth from zero, not a change over time. The next report will provide a comparison.',
  zeroDebt: '0 — no debt',
  hundredDefective: '100 — every item is deficient',

  sourceCalendar: 'Calendar',
  sourceGoogleCalendar: 'Google Calendar',
  sourceYandexCalendar: 'Yandex Calendar',
  sourceOutlookCalendar: 'Outlook Calendar',
  sourceOther: 'Other',
  sourceHasData: 'data available',
  sourceNoData: 'no data',
  sourceNotConnected: 'not connected',
  sourceFailed: 'failed',
  sourceStatusHint: 'Source status from the latest collection run.',

  componentTaskDebt: 'Task quality',
  componentDocumentationDebt: 'Documentation',
  componentTraceabilityDebt: 'Change context',
  componentDecisionDebt: 'Unrecorded decisions',
  componentMeetingDebt: 'Meetings',
  componentKnowledgeConcentration: 'Knowledge concentration',

  signalMissingDescription: 'Missing meaningful description',
  signalMissingAcceptanceCriteria: 'Missing acceptance criteria',
  signalMissingPriority: 'Missing priority',
  signalMissingEstimate: 'Missing estimate',
  signalMissingAssignee: 'Missing owner',
  signalMissingEpicLink: 'Missing epic link',
  signalStaleDocument: 'Not updated recently',
  signalOrphanDocument: 'No inbound links',
  signalThinDocument: 'Too short',
  signalPullRequestWithoutIssue: 'No issue link',
  signalPullRequestUnknownIssue: 'Link to an unknown issue',
  signalPullRequestLongDiscussion: 'Long discussion: {{threshold}}+ comments',
  signalSingleContributor: 'Area with a single contributor',
  signalDominatedArea: 'Area where one contributor owns {{threshold}}% or more',
  signalDecisionWithoutRecord:
    'Decision was discussed but has no document link',
  signalMeetingWithoutAgenda: 'No agenda in the meeting description',
  signalWeeklyMeetingOverload:
    'Above the soft limit of {{threshold}} meetings per week',

  measured: 'Measured',
  estimate: 'Estimate',
  weight: 'weight {{value}}',
  notEvaluated: 'Not evaluated',
  measuredSummary: '{{deficient}} of {{total}} items — {{percent}}',
  estimatedSummary: 'estimated {{low}}…{{high}}',
  assumptionsTitle: 'Estimate assumptions',
  dataCompleteness: 'Available data coverage: {{percent}}',
  assumptionSoftWeeklyLimit: 'Soft weekly limit',
  assumptionHardWeeklyLimit: 'Hard weekly limit',
  unitMeetingShare: 'share of meetings',
  unitMeetingsPerWeek: 'meetings/week',
  show: 'Show',
  hide: 'Hide',
  loadingList: 'Loading list…',
  emptyList: 'The saved report has no items for this signal.',
  drilldownUnavailable: 'Details are unavailable for this report.',
  drilldownLoadError: 'Could not load the list: {{message}}',
  pendingReview: 'pending review',

  economyTitle: 'Estimated cost',
  contextRecoveryCost: 'to restore context for the detected deficiencies',
  range: 'range {{low}} … {{high}}',
  showCalculation: 'Show calculation',
  hideCalculation: 'Hide calculation',
  calculationLine: '{{count}} × {{minutes}} min',
  economyAssumptions:
    'Time constants are assumptions, not measurements. Change them to recalculate the estimate.',
  hourShort: 'h',

  recommendationsTitle: 'Recommended actions',
  effortLow: 'quick',
  effortMedium: 'medium',
  effortHigh: 'longer',
  laplacePreparesDraft: 'Laplace prepares a draft',
  estimatedHours: 'estimated {{low}}…{{high}} h',
  recommendationGenerateTaskDescriptionsTitle:
    'Tasks without meaningful descriptions',
  recommendationGenerateTaskDescriptionsAction:
    'Generate description drafts and send them for review.',
  recommendationGenerateAcceptanceCriteriaTitle:
    'Tasks without acceptance criteria',
  recommendationGenerateAcceptanceCriteriaAction:
    'Generate acceptance criteria from the description and discussion.',
  recommendationAddEstimatesTitle: 'Tasks without estimates',
  recommendationAddEstimatesAction:
    'Add estimates during refinement. This is a team decision and should not be automated.',
  recommendationAssignOwnersTitle: 'Tasks without owners',
  recommendationAssignOwnersAction:
    'Assign owners. The team decides who is accountable.',
  recommendationLinkTasksToEpicsTitle: 'Tasks without epic links',
  recommendationLinkTasksToEpicsAction:
    'Link tasks to epics so their context can be restored from the top down.',
  recommendationRefreshStaleDocumentsTitle: 'Stale documents',
  recommendationRefreshStaleDocumentsAction:
    'Update or archive them. An outdated document is worse than a missing one because people trust it.',
  recommendationLinkOrphanDocumentsTitle: 'Documents without inbound links',
  recommendationLinkOrphanDocumentsAction:
    'Link them to tasks or remove them. A document nobody can find is not useful.',
  recommendationReviewThinDocumentsTitle: 'Documents that are too short',
  recommendationReviewThinDocumentsAction:
    'Expand or merge them. Placeholder pages do not preserve context.',
  recommendationEnforceIssueKeyTitle: 'Pull requests without issue links',
  recommendationEnforceIssueKeyAction:
    'Require issue keys in branch names. This improves the process for future pull requests.',
  recommendationFixUnknownIssueKeysTitle:
    'Pull requests linked to unknown issues',
  recommendationFixUnknownIssueKeysAction:
    'Check issue-key typos and project coverage in the audit.',
  recommendationReducePrClarificationsTitle:
    'Pull requests with long discussions',
  recommendationReducePrClarificationsAction:
    'Review what required clarification. The missing context usually belongs in the task or documentation.',
  recommendationAddMeetingAgendasTitle: 'Meetings without agendas',
  recommendationAddMeetingAgendasAction:
    'Add the expected outcome and questions to recurring meeting descriptions.',
  recommendationReduceWeeklyMeetingsTitle: 'Too many meetings per week',
  recommendationReduceWeeklyMeetingsAction:
    'Review recurring meetings, merge duplicates and replace optional syncs with asynchronous updates.',
  recommendationRecordDecisionsTitle: 'Discussed but unrecorded decisions',
  recommendationRecordDecisionsAction:
    'Create a decision record and link it to the task.',
  recommendationReduceSingleContributorAreasTitle:
    'Areas with a single context owner',
  recommendationReduceSingleContributorAreasAction:
    'Add a second contributor or move the context into documentation.',
  recommendationSpreadAreaOwnershipTitle: 'Areas dominated by one contributor',
  recommendationSpreadAreaOwnershipAction:
    'Distribute at least part of the area’s work more broadly.',

  draftsTitle: 'Drafts',
  draftsSummary: '{{pending}} pending review, {{approved}} ready to apply',
  draftStatusPendingReview: 'pending review',
  draftStatusApproved: 'approved',
  draftStatusRejected: 'rejected',
  draftStatusApplied: 'written to tracker',
  draftStatusFailed: 'write failed',
  field: 'field: {{field}}',
  approve: 'Approve',
  reject: 'Reject',
  retryApply: 'Retry write',
  applyToTracker: 'Write to tracker',
  draftsNote:
    'Nothing is written to the tracker before approval, and the task remains deficient until then.',

  historyTitle: 'Report history',
  clearHistoryConfirmation:
    'Delete all versions? The trend and item details will be lost.',
  clearing: 'Clearing…',
  delete: 'Delete',
  cancel: 'Cancel',
  clearHistory: 'Clear history',
  noChanges: 'no changes',
} as const
